var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],class:['meal-status-icon', _vm.getClass],style:([_vm.getSizeStyle()]),attrs:{"title":_vm.statusName}},[_c('i',{class:`fas fa-${_vm.iconName}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }